import React, { useEffect, useState } from 'react';
import { Selector } from 'react-gldn-kit';
import {
  PaymentChannelType,
  UserInfo,
} from 'react-memory-optimization/dist/lib/store/user/types';
import { useUserInfo } from 'react-render-hooks';

import { useZustandPaymentsStore } from 'stores/money/payments/store';
import { setPaymentsCurrentStepAction } from 'stores/money/payments/selectors';
import { setFormsInfoAction } from 'stores/money/forms/selectors';
import { useZustandFormsStore } from 'stores/money/forms/store';
import { useZustandUserStore } from 'stores/user/personal/store';
import { getUserCurrencyIdSelector } from 'stores/user/personal/selectors';
import { DEFAULT_INPUT_VALUE } from 'components/ui/Input/Base/constant';
import { DefaultInputType } from 'components/ui/Input/Base/types';
import { useHookFabric } from 'hooks/useHookFabric';
import { isFilledForm } from 'utils/validation';
import AmountInput from 'components/ui/Input/AmountInput';
import PhoneInput from 'components/ui/Input/Phone';
import Input from 'components/ui/Input/Base';
import { BANK_CODE } from './constants';

import { Steps } from 'stores/money/payments/types';

import { ERequestIds } from 'react-memory-optimization/dist/lib/binary/types';
import PortalList from '../../PortalList';

import styles from '../Withdraw.module.css';

type Props = {
  limit: { min: number; max: number };
};

const APayPkr = (props: Props) => {
  const { limit } = props;

  const [amount, setAmount] = useState<string>('');

  const [phone, setPhone] = useState<string>('');

  const userInfo = useHookFabric<UserInfo>({ fn: useUserInfo });

  const [accountNumber, setAccountNumber] =
    useState<DefaultInputType>(DEFAULT_INPUT_VALUE);

  const [bankCode, setBankCode] = useState<null | { name: string; id: number }>(
    null
  );

  const currencyId = useZustandUserStore(getUserCurrencyIdSelector);

  const setFormInfo = useZustandFormsStore(setFormsInfoAction);

  const setStep = useZustandPaymentsStore(setPaymentsCurrentStepAction);

  const [isOpenPortal, setPortalState] = useState<boolean>(false);

  const validateInput = (
    inputName: 'bankCode' | 'accountNumber' | 'phoneNumber',
    value: string
  ) => {
    switch (inputName) {
      case 'accountNumber':
        // Validate account number: 10-14 digits only
        return /^[0-9]{10,14}$/.test(value);

      case 'phoneNumber':
        // Validate phone number: exactly 11 digits starting with 03
        return /^03[0-9]{9}$/.test(value);

      case 'bankCode':
        // Validate bank code: 3-65 characters, letters and spaces only
        return /^[A-Za-z\s]{3,65}$/.test(value);

      default:
        return false;
    }
  };
  const handleChangeInput = (inputName: 'accountNumber') => (value: string) => {
    if (inputName === 'accountNumber') {
      const isValid = validateInput('accountNumber', value);

      console.log('🚀 ~ APayPkr ~ isValid:', isValid);

      // Handle account number validation result
      setAccountNumber({
        value,
        errorText: isValid ? '' : 'errors.invalidData',
      });

      return;
    }

    // if (inputName === 'phoneNumber') {
    //   const isValid = validateInput('phoneNumber', value);
    //   // Handle phone number validation result
    //   console.log(`Phone Number ${isValid ? 'valid' : 'invalid'}`);
    //   return;
    // }

    return;
  };

  const handleSaveBankCode = (data: { name: string; id: number }) => () => {
    togglePortalState();
    setBankCode(data);
  };

  const togglePortalState = () => {
    setPortalState(!isOpenPortal);
  };

  useEffect(() => {
    const data = [amount, phone, accountNumber];

    const isFilled = isFilledForm(data);

    console.log('🚀 ~ useEffect ~ isFilled:', isFilled);
    console.log('🚀 ~ useEffect ~ bankCode:', bankCode);
    console.log('🚀 ~ useEffect ~ isFilled []:', [
      amount,
      phone,
      accountNumber,
    ]);

    if (isFilled && currencyId && bankCode?.id !== undefined) {
      setFormInfo({
        isDeposit: false,
        form: {
          amount,
          channelId: PaymentChannelType.APayBankTransfer,
          phoneNumber: `0${phone.slice(3)}`,
          currencyId,
          bankCode: bankCode.name,
          accountNumber: accountNumber.value,
          requestId: ERequestIds.WithdrawRequest,
        },
      });
      setStep(Steps.FilledForm);
    } else {
      setStep(Steps.TypingData);
    }
  }, [currencyId, phone, amount, userInfo, accountNumber, bankCode]);

  return (
    <>
      <AmountInput
        inputStyleType="border-colorful"
        inputLabelType="labelUp"
        placeholder="walletPopUp.forms.amount"
        size="full"
        onChange={setAmount}
        isWithdraw
        isPresets={false}
        min={limit.min}
        max={limit.max}
        wrapperClasses={styles.marginInputBottom}
      />

      {/* Phone */}
      <PhoneInput
        countryCodeDefault="PK"
        withConfirm={false}
        size="full"
        inputStyleType="border-colorful"
        inputLabelType="labelUp"
        sendKey="09x"
        onChange={setPhone}
        isHidePlaceholder={false}
        baseValue="+92"
        placeholder="walletPopUp.forms.phone"
        classesWrapper={styles.marginInputBottom}
      />

      <Input
        placeholder="walletPopUp.forms.accountNumber"
        inputStyleType="border-colorful"
        inputLabelType="labelUp"
        size="full"
        classes={styles.marginInputBottom}
        errorText={accountNumber.errorText}
        onChange={handleChangeInput('accountNumber')}
      />

      <Selector
        placeholder="walletPopUp.forms.bank"
        activeId={!bankCode ? -1 : bankCode?.id}
        selectorStyleType="labelUp"
        handleClick={togglePortalState}
        data={BANK_CODE}
        classes={styles.marginInputBottom}
        type="button"
        isOpenUp
        size="full"
      />

      <PortalList
        isOpen={isOpenPortal}
        data={BANK_CODE}
        activeId={bankCode?.id}
        callback={handleSaveBankCode}
      />
    </>
  );
};

export default APayPkr;
